import { Box, Grid, Accordion, AccordionSummary, Typography, AccordionDetails } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { DebtorDetails, DebtorType } from "../adminInvoicingTypes"
import { InvoiceLinesSectionTable } from "./InvoiceLinesSectionTable"
import { theme } from "../../../../theme/theme"

const useStyles = makeStyles()(() => ({
    container: {
        padding: "2.5rem",
    },
    accordion: {
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
        boxShadow: "none",

        "&:first-of-type": {
            borderTopLeftRadius: "0.75rem",
            borderTopRightRadius: "0.75rem",
        },
        "&:last-of-type": {
            borderBottomLeftRadius: "0.75rem",
            borderBottomRightRadius: "0.75rem",
        },
        "&:before": {
            display: "none",
        },
        "&.Mui-expanded": {
            margin: 0,
        },
    },
    accordionSummary: {
        padding: "1.25rem",
        minHeight: "auto",
        flexDirection: "row-reverse",
        gap: "1.25rem",
        color: theme.palette.tailwind.slate[700],
        "& .MuiAccordionSummary-content": {
            margin: `0`,
            "&.Mui-expanded": {
                margin: 0,
            },
        },
        "&.Mui-expanded": {
            minHeight: "auto",
        },
    },
    accordionDetails: {
        padding: "0 3.25rem 1.25rem 4rem",
        color: theme.palette.tailwind.slate[600],
    },
}))

export function DebtorsDetailsContent({ info }: { info: DebtorDetails }) {
    const { classes } = useStyles()
    return (
        <Box className={classes.container}>
            {info.type === DebtorType.SUPPLIER ? (
                <Grid container flexDirection="column" gap={2.5}>
                    {info.merchants.map((merchant) => (
                        <Accordion className={classes.accordion} key={merchant.id}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <Grid container flexDirection="column">
                                    <Typography variant="body2" fontWeight={600}>
                                        {merchant.name}
                                    </Typography>
                                    <Typography variant="body2">{merchant.address}</Typography>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <InvoiceLinesSectionTable invoiceLines={merchant.invoiceLines} />
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Grid>
            ) : (
                <InvoiceLinesSectionTable invoiceLines={info.invoiceLines} />
            )}
        </Box>
    )
}
